import './suche.css';
import { Link } from 'react-router-dom';
import { makeStyles } from '@material-ui/core/styles';
import { useEffect, useState, useContext } from 'react';
import { DataContext } from '../../context/DataContext';

const useStyles = makeStyles( ( theme ) => ( {
  root: {
    // height:"100%",
    padding: '0px',
    display: 'grid',
    gridTemplateColumns: '50% 50%',
    [ theme.breakpoints.down( 'sm' ) ]: {
      gridTemplateColumns: '100%'
    }
  },
  griditem: {
    padding: '10px',
    width: '100%'
  },
  section_title: {
    // border: "1px solid #000",
    color: '#fff',
    textTransform: 'uppercase',
    fontSize: '14px',
    marginBottom: '10px'
  },
  rounded_corner_right: {
    // border: "1px solid #000",
    backgroundColor: '#ffffff',
    borderRadius: '0px 10px 0px 0px',
    height: '12px',
    width: '100%',
    opacity: 0.8
  },
  rounded_corner_left: {},
  DA_info_container: {
    // border: "1px solid #f0f",
    width: '100%',
    padding: '2px 10px 8px 10px',
    backgroundColor: '#ffffff',
    color: '#000000',
    opacity: 0.8
  },

  DA_box: {
    marginBottom: '8px',
    // width: "90%",
    border: '1px solid #fff',
    backgroundColor: '#ffffff',

    padding: '10px'
  },

  DA_box_highlight: {
    border: '1px solid #55ba5e',
    backgroundColor: '#ffffff',
    padding: '10px'

    // width: "100%",
  },
  DA_info_row: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: '8px'
  },
  DA_info_name: {
    backgroundColor: '#55ba5e',
    color: '#fff',
    padding: '3px',
    width: '70%'
  },
  DA_info_date: {
    color: '#323232',
    fontWeight: 'bold'
  },
  DA_info_checkbox: {},
  box_footer: {
    display: 'flex',
    justifyContent: 'flex-end',
    // fontWeight: "bold",
    padding: '0px 35px',
    alignItems: 'center',
    // border: "1px solid #000",
    height: '30px',
    backgroundColor: '#d0e5d9',
    borderRadius: '0px 0px 0px 10px',
    width: '100%'
    // color:"#55ba5e"
  }
} ) );

export default function Suche ()
{
  const { appToken, appLoggedInChange, appLoggedIn } = useContext( DataContext );

  const classes = useStyles();

  const [ searchString, setSearchString ] = useState( '' );

  const [ kontakteData, setKontakteData ] = useState( {} );
  const [ kontakteHTML, setKontakteHTML ] = useState(
    <div>Bitte geben Sie Ihre Suche ein</div>
  );

  const [ newsData, setNewsData ] = useState( {} );
  const [ newsHTML, setNewsHTML ] = useState(
    <div>Bitte geben Sie Ihre Suche ein</div>
  );

  const [ dateienData, setDateienData ] = useState( {} );
  const [ dateienHTML, setDateienHTML ] = useState(
    <div>Bitte geben Sie Ihre Suche ein</div>
  );

  function getSearchKontakte ()
  {
    var myHeaders = new Headers();
    myHeaders.append( 'Content-Type', 'application/json' );
    myHeaders.append( 'Authorization', `Bearer ` + appToken );
    var requestOptions = {
      method: 'GET',
      headers: myHeaders
    };

    fetch(
      'https://intranet-backend.procuratio.com/api_v2/get_kontakte.php?searchString=' +
      searchString,
      requestOptions
    )
      .then( ( response ) => response.json() )
      .then( ( result ) => setKontakteData( result.data ) )
      .catch( ( error ) => console.log( 'error', error ) );
  }

  function getDateienSearch ()
  {
    var myHeaders = new Headers();
    myHeaders.append( 'Content-Type', 'application/json' );
    myHeaders.append( 'Authorization', `Bearer ` + appToken );
    var requestOptions = {
      method: 'GET',
      headers: myHeaders
    };

    fetch(
      'https://intranet-backend.procuratio.com/api_v2/get_files_search.php?searchString=' +
      searchString,
      requestOptions
    )
      .then( ( response ) => response.json() )
      .then( ( result ) => setDateienData( result.data ) )
      .catch( ( error ) => console.log( 'error', error ) );
  }

  function getNewsSearch ()
  {
    var myHeaders = new Headers();
    myHeaders.append( 'Content-Type', 'application/json' );
    myHeaders.append( 'Authorization', `Bearer ` + appToken );
    var requestOptions = {
      method: 'GET',
      headers: myHeaders
    };

    fetch(
      'https://intranet-backend.procuratio.com/api_v2/get_news_search.php?searchString=' +
      searchString,
      requestOptions
    )
      .then( ( response ) => response.json() )
      .then( ( result ) => setNewsData( result.data ) )
      .catch( ( error ) => console.log( 'error', error ) );
  }

  useEffect( () =>
  {
    // Dateh holen
    if ( searchString.length > 2 )
    {
      getNewsSearch();
      getDateienSearch();
    }
  }, [ searchString ] );

  useEffect( () =>
  {
    // Dateh holen
    getSearchKontakte();
  }, [] );

  useEffect( () =>
  {
    console.log( 'newsData uE', newsData );

    if ( searchString.length > 2 )
    {
      let tmp = Object.values( newsData ).map( function ( value, index )
      {
        return (
          <>
            <div className="rounded_corner_right"></div>
            <div className="DA_info_container">
              <div className="DA_info_row">
                <div className="DA_info_name">
                  {
                    //@ts-ignore
                    value.nachrichten_headline
                  }
                </div>
                <div className="DA_info_date">
                  {
                    //@ts-ignore
                    value.D
                  }
                </div>
              </div>
              <div
                className="headline"
                style={ { fontWeight: 'bold', fontSize: '14px' } }
              >
                {
                  //@ts-ignore
                  value.nachrichten_user
                }{ ' ' }
                (
                {
                  //@ts-ignore
                  value.nachrichten_datum
                }
                )
                <br />
                <Link
                  to={
                    //@ts-ignore
                    '/nachricht/' + value.nachrichten_id
                  }
                  className="a_header"
                >
                  LINK
                </Link>
              </div>
            </div>
            <br />
          </>
        );
      } );
      //@ts-ignore
      setNewsHTML( tmp );
    } else
    {
      setNewsHTML(
        <div>Bitte geben Sie mindestens 3 Buchstaben in der Suche an</div>
      );
    }
  }, [ newsData, searchString ] );

  useEffect( () =>
  {
    console.log( 'dateienData uE', dateienData );
    if ( searchString.length > 2 )
    {
      //@ts-ignore
      let tmp = Object.values( dateienData ).map( function ( value: String )
      {
        console.log( 'dateien value', value );
        return (
          <>
            <div className="rounded_corner_right"></div>
            <div className="DA_info_container">
              <div className="DA_info_row">
                <div className="DA_info_name">
                  {
                    //@ts-ignore
                    value
                  }
                </div>
              </div>
              <div
                className="headline"
                style={ { fontWeight: 'bold', fontSize: '14px' } }
              >
                <a
                  href={
                    //@ts-ignore
                    'https://intranet-backend.procuratio.com/./' + value
                  }
                  className="a_header"
                  target="_blank"
                >
                  LINK
                </a>
              </div>
            </div>
            <br />
          </>
        );
      } );
      //@ts-ignore
      setDateienHTML( tmp );
    } else
    {
      setDateienHTML(
        <div>Bitte geben Sie mindestens 3 Buchstaben in der Suche an</div>
      );
    }
  }, [ dateienData ] );

  useEffect( () =>
  {
    setNewsHTML( <div>Suche...</div> );
    if ( searchString.length > 2 )
    {
      let tmp = Object.values( kontakteData ).map( function ( value: any, index )
      {
        const is_given = ( val: any ) =>
        {
          if ( val === null ) return false;
          if ( val === '' ) return false;
          return true;
        };
        let mapping_field_value = {
          kostenstelle: 'A',
          vorname: 'B',
          nachname: 'C',
          funktion: 'D',
          firma: 'E',
          adresszusatz: 'F',
          strasse: 'G',
          hausnummer: 'H',
          plz: 'I',
          ort: 'J',
          tel: 'K',
          tel_buero: 'L',
          tel_kueche: 'M',
          fax: 'N',
          handy: 'O',
          mail: 'P',
          personalisierte_mail: 'Q'
        };
        let value_tmp = JSON.stringify( value ).toLowerCase();
        if ( value_tmp.includes( searchString.toLowerCase() ) )
        {
          return (
            <>
              <div className="rounded_corner_right"></div>
              <div className="DA_info_container">
                <div className="DA_info_row">
                  <div className="DA_info_name">
                    Kostenstelle { value[ mapping_field_value[ 'kostenstelle' ] ] }
                  </div>
                  <div className="DA_info_date">
                    { value[ mapping_field_value[ 'firma' ] ] }
                  </div>
                </div>
                <div
                  className="headline"
                  style={ { fontWeight: 'bold', fontSize: '14px' } }
                >
                  { !is_given( value[ mapping_field_value[ 'vorname' ] ] ) ? null : (
                    <span>{ value[ mapping_field_value[ 'vorname' ] ] }</span>
                  ) }
                  { !is_given( value[ mapping_field_value[ 'nachname' ] ] ) ? null : (
                    <span>&nbsp;{ value[ mapping_field_value[ 'nachname' ] ] }</span>
                  ) }
                  { !is_given( value[ mapping_field_value[ 'funktion' ] ] ) ? null : (
                    <span>
                      &nbsp;({ value[ mapping_field_value[ 'funktion' ] ] })
                    </span>
                  ) }
                  <br />
                  <br />
                  {/* Adresse:
                  <br />
                  <br /> */}
                  { !is_given( value[ mapping_field_value[ 'firma' ] ] ) ? null : (
                    <p style={ { margin: '0', padding: '0' } }>
                      { value[ mapping_field_value[ 'firma' ] ] }
                    </p>
                  ) }
                  { !is_given(
                    value[ mapping_field_value[ 'adresszusatz' ] ]
                  ) ? null : (
                    <p style={ { margin: '0', padding: '0' } }>
                      { value[ mapping_field_value[ 'adresszusatz' ] ] }
                    </p>
                  ) }
                  { !is_given( value[ mapping_field_value[ 'strasse' ] ] ) ? null : (
                    <p style={ { margin: '0', padding: '0' } }>
                      { value[ mapping_field_value[ 'strasse' ] ] }
                      { !is_given(
                        value[ mapping_field_value[ 'hausnummer' ] ]
                      ) ? null : (
                        <span>
                          &nbsp;{ value[ mapping_field_value[ 'hausnummer' ] ] }
                        </span>
                      ) }
                    </p>
                  ) }
                  { !is_given( value[ mapping_field_value[ 'plz' ] ] ) ? null : (
                    <p style={ { margin: '0', padding: '0' } }>
                      { value[ mapping_field_value[ 'plz' ] ] }
                      { !is_given( value[ mapping_field_value[ 'ort' ] ] ) ? null : (
                        <span>&nbsp;{ value[ mapping_field_value[ 'ort' ] ] }</span>
                      ) }
                    </p>
                  ) }
                  <br />
                  { !is_given( value[ mapping_field_value[ 'tel' ] ] ) ? null : (
                    <p style={ { margin: '0', padding: '0' } }>
                      Telefon:&nbsp;
                      <a href={ 'tel:' + value[ mapping_field_value[ 'tel' ] ] }>
                        { value[ mapping_field_value[ 'tel' ] ] }
                      </a>
                    </p>
                  ) }
                  { !is_given( value[ mapping_field_value[ 'tel_buero' ] ] ) ? null : (
                    <p style={ { margin: '0', padding: '0' } }>
                      Telefon Büro:&nbsp;
                      <a
                        href={ 'tel:' + value[ mapping_field_value[ 'tel_buero' ] ] }
                      >
                        { value[ mapping_field_value[ 'tel_buero' ] ] }
                      </a>
                    </p>
                  ) }
                  { !is_given(
                    value[ mapping_field_value[ 'tel_kueche' ] ]
                  ) ? null : (
                    <p style={ { margin: '0', padding: '0' } }>
                      Telefon Küche:&nbsp;
                      <a
                        href={ 'tel:' + value[ mapping_field_value[ 'tel_kueche' ] ] }
                      >
                        { value[ mapping_field_value[ 'tel_kueche' ] ] }
                      </a>
                    </p>
                  ) }
                  { !is_given( value[ mapping_field_value[ 'fax' ] ] ) ? null : (
                    <p style={ { margin: '0', padding: '0' } }>
                      Fax:&nbsp;
                      <a href={ 'tel:' + value[ mapping_field_value[ 'fax' ] ] }>
                        { value[ mapping_field_value[ 'fax' ] ] }
                      </a>
                    </p>
                  ) }
                  { !is_given( value[ mapping_field_value[ 'handy' ] ] ) ? null : (
                    <p style={ { margin: '0', padding: '0' } }>
                      Handy:&nbsp;
                      <a href={ 'tel:' + value[ mapping_field_value[ 'handy' ] ] }>
                        { value[ mapping_field_value[ 'handy' ] ] }
                      </a>
                    </p>
                  ) }
                  { !is_given( value[ mapping_field_value[ 'mail' ] ] ) ? null : (
                    <p style={ { margin: '0', padding: '0' } }>
                      Mail:&nbsp;
                      <a href={ 'tel:' + value[ mapping_field_value[ 'mail' ] ] }>
                        { value[ mapping_field_value[ 'mail' ] ] }
                      </a>
                    </p>
                  ) }
                  { !is_given(
                    value[ mapping_field_value[ 'personalisierte_mail' ] ]
                  ) ? null : (
                    <>
                      persönliche Mail:&nbsp;
                      <a
                        href={
                          'mailto:' +
                          value[ mapping_field_value[ 'personalisierte_mail' ] ]
                        }
                      >
                        { value[ mapping_field_value[ 'personalisierte_mail' ] ] }
                      </a>
                    </>
                  ) }
                </div>
              </div>
              <br />
            </>
          );
        } else
        {
          return null;
        }
      } );
      //@ts-ignore
      setKontakteHTML( tmp );
    } else
    {
      setKontakteHTML(
        <div>Bitte geben Sie mindestens 3 Buchstaben in der Suche an</div>
      );
    }
  }, [ kontakteData, searchString ] );

  return (
    <>
      <div id="wrapper">
        <div className="container_home">
          <div>
            <input
              type="text"
              placeholder="Bitte geben Sie Ihre Suche ein"
              onChange={ ( e ) => setSearchString( e.target.value ) }
              style={ { marginBottom: '40px' } }
            />
          </div>

          <div>
            <div
              className="section_title"
              style={ { marginBottom: '10px' } }
            >
              Kontakte
            </div>
            { kontakteHTML }
          </div>

          <div>
            <div>
              <div
                className="section_title"
                style={ { marginBottom: '10px' } }
              >
                Dateien
              </div>
              { dateienHTML }
            </div>
            <div
              className="section_title"
              style={ { marginBottom: '10px' } }
            >
              News
            </div>
            { newsHTML }
          </div>
        </div>
      </div>
    </>
  );
}
